import { isPlatformBrowser } from "@angular/common";
import { Component, OnInit, Input, ViewChild, Inject, PLATFORM_ID } from "@angular/core";
import {
  NgbDatepickerConfig,
  NgbDateParserFormatter,
} from "@ng-bootstrap/ng-bootstrap";
import { NgbDateCustomParserFormatter } from "src/app/functions/ngb-date-fr-parser-formatter";
import { RestService } from "src/app/services/rest.service";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import * as moment from "moment";
import { Person } from "src/app/models/formData";
import { LOCAL_STORAGE } from "@ng-toolkit/universal";
import { saveAs } from "file-saver";
import { ServiceSEOService } from "src/app/services/service-seo.service";
import { AppComponent } from "src/app/app.component";
import Swal from "sweetalert2";
import { MatRadioChange } from "@angular/material/radio";
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: "app-check-status",
  templateUrl: "./check-status.component.html",
  styleUrls: ["./check-status.component.css"],
  providers: [
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
  ],
})
export class CheckStatusComponent implements OnInit {
  maintenance: boolean;
  date_maintenance: string;
  captchaImage: any;
  isImageLoading: boolean;
  suspenseDownload: boolean = false;
  application_id;
  passport_number;
  notfound = false;
  processing = false;
  rejected = false;
  approved = false;
  banned = false;
  unpaid = false;
  can_edit = false;
  model_verify: any = {};
  message: string;
  isNotSuccess: boolean;
  have_result: boolean;
  isSuccess: boolean;
  reasons;
  created_date;
  updated_date;
  @Input() formData: FormData;
  @ViewChild("bcelForm", { static: false }) testFormEl;
  mPaymentMethod: any[];
  selected_payment_method;
  selected_payment_active;
  selected_payment_method_text;

  node_static_url = environment.node_static_url;
  person: Person;
  mDataArrayPerson: any[];
  invoice_uuid = "";
  total = 0;
  countTotal = 0;
  isEmptyCart = false;
  timeLeft = 0;
  interval;
  model;
  cancelled: boolean;
  action_status: any;
  clicked = false;
  comment;
  status_message: any;
  my_uuid = "";
  constructor(
    @Inject(LOCAL_STORAGE) private localStorage: any,
    @Inject(PLATFORM_ID) private platformId: Object,
    config: NgbDatepickerConfig,
    private router: Router,
    private rest: RestService,
    private seo: ServiceSEOService,
    private app: AppComponent,
    public spinner: NgxSpinnerService
  ) {
    this.seo.addMetaTags();
    config.minDate = { year: 1900, month: 1, day: 1 };
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.getImageFromService();
    }
    this.getMaintenanceService();
  }

  createImageFromBlob(image: Blob) {
    if (!isPlatformBrowser(this.platformId) || typeof FileReader === "undefined") {
      return;
    }
    const reader = new FileReader();
    reader.addEventListener(
      "load",
      () => {
        this.captchaImage = reader.result;
      },
      false
    );

    if (image) {
      reader.readAsDataURL(image);
    }
  }
  getImageFromService() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.isImageLoading = true;
    this.rest.getCaptchaImage().subscribe(
      (data) => {
        this.createImageFromBlob(data);
        this.isImageLoading = false;
      },
      (error) => {
        this.isImageLoading = false;
        console.log(error);
      }
    );
  }

  getMaintenanceService() {
    // this.rest.getMaintenance().subscribe(
    //   (data) => {
    //     this.maintenance = data.maintenance;
    //     this.date_maintenance = data.date_maintenance;
    //   },
    //   (error) => {
    //     console.log(error);
    //   }
    // );
  }

  reloadCaptcha() {
    this.getImageFromService();
  }
  onSubmit(form: any) {
    this.spinner.show();
    this.processing = false;
    this.notfound = false;
    this.rejected = false;
    this.banned = false;
    this.clicked = false;
    if (form.valid) {
      this.rest
        .verifyCaptchaCheckStatus(this.model_verify)
        .subscribe((result) => {
          this.spinner.hide();
          if (result.responseStatus === false) {
            this.isNotSuccess = true;
            this.message = "Security code is wrong!";
            this.getImageFromService();
          } else {
            this.getImageFromService();
            this.localStorage.setItem(
              environment.localAuthenInfo,
              JSON.stringify(result)
            );
            this.rest.checkStatus(this.model_verify).subscribe((rs) => {
              this.have_result = true;
              this.isSuccess = true;
              console.log("Result Status form Back End:", rs);
              if (rs.status === "notfound") {
                this.notfound = true;
                this.localStorage.removeItem(environment.localAuthenInfo);
              } else if (rs.status === "processing") {
                this.processing = true;
                this.created_date = rs.created_date;
                if (rs.updated_date) {
                  this.updated_date = rs.updated_date;
                }
                this.localStorage.removeItem(environment.localAuthenInfo);
              } else if (rs.status === "rejected") {
                this.rejected = true;
                this.action_status = rs.action_status;
                this.reasons = rs.reason_rejected;
                this.created_date = rs.created_date;
                if (rs.updated_date) {
                  this.updated_date = rs.updated_date;
                }
                this.comment = rs.comment;
                this.my_uuid = rs.id;

                if (rs.can_edit == "yes") {
                  this.can_edit = true;
                } else {
                  this.can_edit = false;
                }
              } else if (rs.status === "approved") {
                this.approved = true;
                this.created_date = rs.created_date;
                if (rs.updated_date) {
                  this.updated_date = rs.updated_date;
                }
                this.my_uuid = rs.id;
              } else if (rs.status === "banned") {
                this.banned = true;
                this.reasons = rs.reason_rejected;
                this.created_date = rs.created_date;
                if (rs.updated_date) {
                  this.updated_date = rs.updated_date;
                }
                this.comment = rs.comment;
                this.localStorage.removeItem(environment.localAuthenInfo);
              } else if (rs.status === "unpaid") {
                this.unpaid = true;
                this.invoice_uuid = rs.invoice_uuid;
                this.created_date = rs.created_date;
                if (rs.updated_date) {
                  this.updated_date = rs.updated_date;
                }
                this.selected_payment_method = "";
                this.my_uuid = rs.id;
              } else if (rs.status === "cancelled") {
                this.cancelled = true;
                this.localStorage.removeItem(environment.localAuthenInfo);
              }
              if (this.app.SelectedLang == "en") {
                this.status_message = rs.message;
              } else if (this.app.SelectedLang == "cn") {
                this.status_message = rs.message_cn;
              } else if (this.app.SelectedLang == "fr") {
                this.status_message = rs.message_fr;
              }
            });
          }
        });
    }
  }
  editApplication() {
    this.router.navigate([
      "/edit-application/" + this.model_verify.application_id,
    ]);
  }
  back() {
    this.have_result = false;
    this.model_verify.verify_code = "";
    this.clicked = false;
  }
  // DownLoad PDF
  downloadPdf() {
    const app_id = this.model_verify.application_id;
    const passport_number = this.model_verify.passport_number;
    const verify_code = this.model_verify.verify_code;
    const data_download = {
      application_id: app_id,
      passport_number: passport_number,
      verify_code: verify_code,
      id: this.my_uuid,
    };
    this.spinner.show();
    this.rest.downloadPDF(data_download).subscribe(async (result) => {
      const filename = app_id;
      saveAs(result, this.my_uuid + ".pdf");
      this.spinner.hide();
    });
  }
}
